import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import ConfirmQueryData from '../../../../../components/ConfirmQueryData';
import FormContainer from '../../../../../components/FormContainer';
import StepProgress from '../../../../../components/StepProgress';
import PageLoader from '../../../../../components/PageLoader';
import Accordion from '../../../../../components/Accordion';
import Input from '../../../../../components/Inputs/Input';
import Button from '../../../../../components/Button';
import Alert from '../../../../../components/Alert';
import Icon from '../../../../../components/Icons';

import { ContainerButton, PageContainer } from '../../../../../styles/styles';

import { cloneObject, downloadFile } from '../../../../../utils';
import steps from '../../../../../utils/steps.json';

import schema from './schema';
import * as S from './styles';

import { gerarProtcoloConsulta, gravaAgendaConsulta, gerarPdfAgendaConsulta } from '../../../../../services';
import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';

function DadosConfirmar({ location: { dataBeneficiario } }) {
    const history = useHistory();
    const { telefoneConsulta, emailConsulta, dataConsultaAtendimento } = useBeneficiarioEventual();
    const [dataForm, setDataForm] = useState(cloneObject(schema));
    const [pageLoading, setPageLoading] = useState(false);
    const [successOpenOrder, setSuccessOpenOrder] = useState(false);
    const [errorOpenOrder, setErrorOpenOrder] = useState(false);
    const [ptcCod, setPtcCod] = useState();
    const [pdfFile, setPdfFile] = useState();

    const telDDD = telefoneConsulta.replace(/[^0-9]/g, '').substring(0, 2);
    const telTelefone = telefoneConsulta.replace(/[^0-9]/g, '').substring(2);

    const successTitle = 'Sua consulta foi agendada com sucesso!';
    const error = 'Atenção';
    const errorTitle = 'Consulta não efetivada. Em caso de dúvida entrar em contato através do Fale Conosco.';
    const succesTitleAgendamento = 'As informações de agendamento foram encaminhadas para seu e-mail!';

    async function loadData() {
        setPageLoading(true);

        const initialValues = {
            ...dataForm,
            email: {
                ...dataForm.email,
                value: emailConsulta,
            },
            cellphone: {
                ...dataForm.cellphone,
                value: telefoneConsulta,
            },
        };

        setDataForm({
            ...dataForm,
            ...initialValues,
        });
        setPageLoading(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    async function handleDownloadRelatorio(row) {
        setPageLoading(true);

        downloadFile('Agendamento', `data:application/pdf;base64,${row}`);

        setPageLoading(false);
    }

    async function handleFowardStep() {
        setPageLoading(true);

        const payloadProtocolo = {
            cabecalho: {
                canal: 'M',
                codigoEmpresaOrigem: '1',
                divisaoNegocio: '1',
                empresaOrigemAtendimento: '1',
                origemContrato: '1',
                tipoContrato: '1',
                token: '1',
                unidadeNegocio: '1',
            },
            acaoRealizada: '17',
            carteirinha: dataConsultaAtendimento.beneficiarioEventual.numCarteira,
            codigoANSOperadora: '359017',
            divisao: 'IMS',
            origemAtendimento: '1',
        };

        const responseProtocol = await gerarProtcoloConsulta(payloadProtocolo);

        if (responseProtocol) {
            const payloadGravarAgenda = {
                cabecalho: {
                    codigoEmpresaOrigem: '1',
                    unidadeNegocio: '1',
                    divisaoNegocio: '1',
                    origemContrato: '1',
                    empresaOrigemAtendimento: '1',
                    tipoContrato: '1',
                    canal: 'M',
                    token: '1',
                },
                consultaID: dataBeneficiario.agendaId,
                consultaSequencia: dataBeneficiario.consultaId,
                carteirinha: dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                email: emailConsulta.value,
                dddTelefoneResidencial: '',
                telefoneResidencial: '',
                dddTelefoneComercial: 0,
                telefoneComercial: 0,
                dddTelefoneCelular: telDDD,
                telefoneCelular: telTelefone,
                dddTelefoneCelularAlternativo: 0,
                telefoneCelularAlternativo: 0,
                indicativoEnvioEmail: 'S',
                indicativoEnvioSMS: 'S',
                usuario: 'PSIAPL',
                protocoloAgendamento: responseProtocol.protocolo,
            };

            await gravaAgendaConsulta(payloadGravarAgenda).then((el) => {
                if (el) {
                    if (el.ptcCod) {
                        setPtcCod(el.ptcCod);
                        setSuccessOpenOrder(true);
                    } else {
                        setSuccessOpenOrder(false);
                        setErrorOpenOrder(true);
                    }
                }
            });

            const payloadGeraPdf = {
                cabecalho: {
                    canal: 'M',
                    codigoEmpresaOrigem: '1',
                    divisaoNegocio: '1',
                    empresaOrigemAtendimento: '1',
                    origemContrato: '1',
                    tipoContrato: '1',
                    token: '1',
                    unidadeNegocio: '1',
                },
                carteirinha: dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                codigoEndereco: '20',
                codigoPrestador: '0',
                ddd: '',
                email: '',
                idConsulta: dataBeneficiario.agendaId,
                sequenciaConsulta: dataBeneficiario.consultaId,
                telefoneCelular: '',
            };

            await gerarPdfAgendaConsulta(payloadGeraPdf).then((el) => {
                if (el) {
                    setPdfFile(el.pdf);
                }
            });
        }
        setPageLoading(false);
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        const field = {
            ...cloneObject(dataForm[id]),
            value,
            lookup,
            unmaskedValue,
            error: '',
            ...rest,
        };

        setDataForm({
            ...dataForm,
            [id]: field,
        });
    }

    return (
        <PageContainer>
            {successOpenOrder ? (
                <>
                    <StepProgress steps={steps.agendamentoConsulta} activeStep={6} />
                    <Alert type={3} title={successTitle} message={succesTitleAgendamento} />
                    <S.DivPDF>
                        <div>
                            <span>
                                N° de protocolo: <p>{ptcCod}</p>
                            </span>
                        </div>

                        <div className="DivPDFDownload" onClick={() => handleDownloadRelatorio(pdfFile)}>
                            <div>
                                <Icon size={24} title="Download" name="download" color="#EC6E0C" />
                            </div>
                            <div>
                                <strong style={{ color: '#EC6E0C' }}>Baixar PDF</strong>
                            </div>
                        </div>
                    </S.DivPDF>

                    <S.ButtonContainerSucesso>
                        <div>
                            <Button
                                id="continueStep"
                                type="primary"
                                onClick={() => {
                                    history.push(
                                        '/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta'
                                    );
                                }}
                            >
                                Novo Agendamento
                            </Button>
                        </div>
                    </S.ButtonContainerSucesso>
                </>
            ) : (
                <>
                    <StepProgress steps={steps.agendamentoConsulta} activeStep={5} />
                    <Accordion
                        title="Precisamos que você confirme alguns dados pra gente, tudo bem?"
                        hasCollapse={false}
                    >
                        <p>{dataConsultaAtendimento.beneficiarioEventual.nomeAssociado}</p>
                        <FormContainer>
                            <Input field={dataForm.email} disabled onChange={handleChangeInput} />
                            <Input field={dataForm.cellphone} disabled onChange={handleChangeInput} />
                        </FormContainer>
                    </Accordion>
                    <ConfirmQueryData dataBeneficiario={dataBeneficiario} />
                    {errorOpenOrder ? <Alert type={1} title={error} message={errorTitle} /> : ''}

                    <ContainerButton>
                        <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                            Voltar
                        </Button>

                        <Button id="continueStep" type="primary" onClick={handleFowardStep}>
                            Finalizar
                        </Button>
                    </ContainerButton>
                    <PageLoader loading={pageLoading} />
                </>
            )}
        </PageContainer>
    );
}

export default DadosConfirmar;
